import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";

// const production = true;
const production =
  process.env.VUE_APP_NODE_ENV === 'production';

let firebaseConfig = {}
if (production) {
  firebaseConfig = {
    apiKey: "AIzaSyCfBDXdpMeEfE0c0BAIIbglni2_GW4PgVk",
    authDomain: "avt-nobunaga-261b3.firebaseapp.com",
    databaseURL: "https://avt-nobunaga-261b3.firebaseio.com",
    projectId: "avt-nobunaga-261b3",
    storageBucket: "avt-nobunaga-261b3.appspot.com",
    messagingSenderId: "672227547638",
    appId: "1:672227547638:web:b68759941e044c0e1a4fd7",
    measurementId: "G-R4YRZ5DRD6",
  };
} else {
  firebaseConfig = {
    apiKey: "AIzaSyCNWIG_CdKZensi9XVoG7RRkxlnZvZWSs0",
    authDomain: "avt-nobunaga-dev.firebaseapp.com",
    projectId: "avt-nobunaga-dev",
    storageBucket: "avt-nobunaga-dev.appspot.com",
    messagingSenderId: "335366356518",
    appId: "1:335366356518:web:f541a19a265cf6012f70e7"
  };
}

export const firebaseApp = firebase.initializeApp(firebaseConfig);
export const db = firebaseApp.firestore();
export const auth = firebaseApp.auth();
